import axios from 'axios';

// 封装 axios
// resolve 格式化的response
// reject [格式化后的error, 上报的error]
const request = axios.create({
  baseURL: '/api/',
  // 自定义请求头信息
  headers: {
    // 'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json;charset=UTF-8',
  },
  // 超时时间
  // timeout: 10000,
  // 跨域是否携带身份凭证
  withCredentials: false, // default
  // 返回数据的格式arraybuffer,blob,document,json,text,stream
  responseType: 'json', // default
  // xsrf
  xsrfCookieName: 'XSRF-TOKEN', // default
  xsrfHeaderName: 'X-XSRF-TOKEN', // default
  // http响应内容的最大值
  maxContentLength: 2000,
  // `validateStatus`定义了是否根据http相应状态码，来resolve或者reject promise
  // 如果`validateStatus`返回true(或者设置为`null`或者`undefined`),那么promise的状态将会是resolved,否则其状态就是rejected
  validateStatus: function(status) {
    return status >= 200 && status < 400; // default
  },
});

// POST传参序列化
request.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    return Promise.reject([
      {
        code: 400,
        success: false,
        message: '错误的传参!',
        data: {},
      },
      {
        response: error,
      },
    ]);
  },
);

// code状态码200判断
request.interceptors.response.use(
  res => {
    // 如果返回html
    if (typeof res.data === 'string' && (res.data.includes('<!DOC') || res.data.includes('<!doc'))) {
      return Promise.reject([
        {
          code: 400,
          success: false,
          message: '错误的传参!',
          data: {},
        },
        {
          response: res,
        },
      ]);
    }
    return Promise.resolve({
      code: res.status,
      message: 'OK',
      success: true,
      data: res.data || {},
    });
  },
  error => {
    return Promise.reject([
      {
        code: (error.response && (error.response.data.code || error.response.status)) || '5000',
        success: false,
        message:
          (error.response && (error.response.data.message || error.response.data.msg)) ||
          '网络有点慢,换个姿势再来一次!',
        data: (error.response && error.response.data) || '',
      },
      {
        response: error.response || error.stack || '',
      },
    ]);
  },
);

export default request;
